import { createSlice } from '@reduxjs/toolkit'

import { scheduleSelectors } from '../selectors/schedule'

const initialState = {
    items: [],
    total: 0,
    isLoading: false,
    error: null,
    saveLoading: false,
    deleteLoading: false,
    occupancy: {
        items: [],
        isLoading: false,
    },
}

const schedule = createSlice({
    name: 'schedule',
    initialState,
    reducers: {
        setScheduleLoading: (state, action) => {
            state.isLoading = action.payload
        },
        setScheduleData: (state, action) => {
            state.items = action.payload.items
            state.total = action.payload.total
            state.error = null
        },
        setScheduleError: (state, action) => {
            state.error = action.payload
            state.items = []
            state.total = 0
        },
        setSaveLoading: (state, action) => {
            state.saveLoading = action.payload
        },
        setDeleteLoading: (state, action) => {
            state.deleteLoading = action.payload
        },
        setOccupancyLoading: (state, action) => {
            state.occupancy.isLoading = action.payload
        },
        setOccupancyData: (state, action) => {
            state.occupancy.items = action.payload
        },
        resetOccupancy: (state) => {
            state.occupancy.items = []
            state.occupancy.isLoading = false
        },
        resetSchedule: () => initialState,
    },
    selectors: {
        ...scheduleSelectors,
    },
})

export const scheduleSelector = schedule.getSelectors()
export const scheduleActions = schedule.actions

export default schedule.reducer
